import { map } from "rxjs/operators";
import { moduleEnum } from "./../../../core/Enums/moduleEnum";
import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "src/app/core/helpers/helper.service";
import { NotificationService } from "src/app/core/services/notification/notification.service";
declare var $: any;
declare function DateRangpicker(): any;
@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
})
export class NotificationsComponent implements OnInit {
  pageConfig: any = {
    curPage: 1,
    perPage: 10,
    whereClause: [],
  };
  filters: any = {
    Module: null,
    Company: null,
    moduleId: null,
    startDate:null,
    endDate:null
  };
  total: any;
  notificationData: any;
  actionData: any[][]=[];
  comapanyData: any;
  moduleData: any;
  filterDate:any;

  constructor(
    private notification: NotificationService,
    private spinner: NgxSpinnerService,
    private helperService: HelperService
  ) {}

  ngOnInit(): void {
    // this.today = new Date().toISOString().split('T')[0];
    setTimeout(() => {
      DateRangpicker();
    }, 100);
    this.getModuleByPermission();
    this.onPagination();
  }

  getModuleByPermission() {
    this.spinner.show();
    this.notification.getModule().subscribe((res: any) => {
      if (res.statusCode == 200) {
        this.spinner.hide();
        this.actionData = this.flattenData(res.data.actionModule);
        this.comapanyData = res.data.companyIds;
        this.moduleData = res.data.modules[0];
      } else {
        this.spinner.hide();
      }
    });
  }

  flattenData(data: any[][]): any[] {
    return data.reduce((i, j) => i.concat(j), []);
  }

  getColor(module: string): string {
    switch (module) {
      case 'AUDIT:Approve Action.':
        return 'green';
      case 'AUDIT:Reject Action.':
        return 'red';
      default:
        return '';
    }
  }

  onPagination() {
    this.spinner.show();
    this.pageConfig.whereClause = this.helperService.getAllFilters(
      this.filters
    );
    this.notification
      .notifiactionPagination(this.pageConfig)
      .subscribe((res: any) => {
        if (res.statusCode == 200) {
          this.spinner.hide();
          this.notificationData = res.data.notifications;
          this.total = res.data.totalCount;
        } else {
          this.notificationData = [];
          this.total = 0;
          this.spinner.hide();
        }
      });
  }

  OnPerPageChange(event?: any) {
    this.pageConfig.curPage = 1;
    if (event) this.pageConfig.perPage = +event.target.value;
    this.onPagination();
  }

  onGetPage(page: number) {
    this.pageConfig.curPage = page;
    this.onPagination();
  }

  clearFilter(){
    this.filters.Module=null;
    this.filters.Company=null;
    this.filters.moduleId=null;
    this.filters.startDate=null;
    this.filters.endDate=null;
    this.filterDate=null;
    DateRangpicker();
    this.onPagination();
  }

  onDateFilterApply() {
    var completeDate = $('input[name="customDateRangPicker"]')[0].value;
    if (completeDate) {
      var dateArray = completeDate.split('/');
      // this.filters = {
        this.filters.startDate= dateArray[0],
        this.filters.endDate= dateArray[1]
      // }
      this.onPagination();
    } else {
      this.clearFilter();
    }
  }
}
